import clsx from "clsx";

interface BadgeButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const BadgeButton = ({ label, isActive, onClick }: BadgeButtonProps) => {
  return (
    <button
      className={clsx("brand-badge-button-default", {
        "is-active": isActive,
      })}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default BadgeButton;
